const CHUNK_RELOAD_SESSION_KEY = "marketplace:chunk-load-reload";

const CHUNK_LOAD_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /Loading chunk [\d]+ failed/i,
  /error loading dynamically imported module/i,
];

/** @param {unknown} error */
export function isChunkLoadError(error) {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : error && typeof error === "object" && "message" in error
          ? String(error.message)
          : String(error ?? "");
  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}

/**
 * Reload once when a lazy route chunk is missing (stale index.html after deploy).
 * @returns {boolean} true if a reload was triggered
 */
export function reloadOnceOnChunkLoadError() {
  if (sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY)) {
    return false;
  }
  sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, "1");
  window.location.reload();
  return true;
}

export { CHUNK_RELOAD_SESSION_KEY };
